import React from 'react';

import { Site } from '@99designs/common/apps/global-nav/lib/Site';

import Bugsnag from 'common/Bugsnag/Bugsnag';
import Layout from 'common/Layout/Layout';

interface State {
    error?: Error;
}

interface Props {
    site: Site;
}

import ErrorView from 'common/FullscreenError/FullscreenError';

class ErrorBoundary extends React.Component<Props, State> {
    state: State = {};

    componentDidCatch(error: Error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;

        if (error) {
            Bugsnag.notify(error);

            return (
                <Layout role="logged-out" site={this.props.site}>
                    <ErrorView error={error} errorCode="500" />
                </Layout>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
